module.exports = __webpack_public_path__ + "img/明爱.e9ff214.png";